import {
  Box,
  Button,
  Checkbox,
  FormControl,
  // FormControl,
  FormControlLabel,
  FormLabel,
  // FormLabel,
  InputLabel,
  Radio,
  RadioGroup,
  // Radio,
  // RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FieldArray, useFormik } from 'formik';
import { get, includes, indexOf, isArray, isString } from 'lodash';
import React, { useState } from 'react';
import { ChevronsDown, ChevronsUp } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

// Components
import FormItemCountryMulti from 'src/components/Form/FormItemCountryMulti';
import FormItemIndustryPeople from 'src/components/Form/FormItemIndustryPeople';
import ModalComponent from 'src/components/Modal/ModalComponent';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import FormikForm from 'src/components/common/FormikForm';
import FormItemStatePeople from 'src/features/PeopleDetail/Common/FormItemStatePeople';
import FormItemSuggestCompany from 'src/features/PeopleDetail/Common/FormItemSuggestCompany';
import FormItemSuggestName from 'src/features/PeopleDetail/Common/FormItemSuggestName';
// import FormItemSuggestJobTitle from 'src/features/PeopleDetail/Common/FormItemSuggestJobTitle';

// Utilities
import IconFeather from 'src/components/common/Icon';
import { SanctionsStatus, SearchPeopleStatus, SearchProfileIncludes } from 'src/features/PeopleDetail/Common/config';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { useQueryRuntimeConfig } from 'src/services/queries/useQueryRuntimeConfig';
import { LIMIT_GET_LIST_PEOPLE } from 'src/utils/constants/config';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { PEOPLE_URL_VIDEO } from 'src/utils/constants/videosUrl';
import { handleQueryParamFromObject } from 'src/utils/helpers/queryParam';

interface IProps {
  open: boolean;
  handleClose: () => void;
}
const FormSearchPeople: React.FC<IProps> = ({ open, handleClose }) => {
  const navigate = useNavigate();
  const [visibleMoreFilter, setVisibleMoreFilter] = useState(false as boolean);
  const {
    data: { data: runTimeConfig },
  } = useQueryRuntimeConfig();

  const params = useQueryParams();

  const getDefaultValue = (key: string) => {
    return get(params, key, '') as string;
  };

  const getDefaultArray = (key: string) => {
    const value = params[key];
    if (isArray(value)) {
      return value as ExpectedAny[];
    }
    if (isString(value)) {
      return [value] as string[];
    }
    return [];
  };
  const formik = useFormik<TypePeopleSearch>({
    enableReinitialize: true,
    initialValues: {
      limit: LIMIT_GET_LIST_PEOPLE,
      offset: 0,
      name: getDefaultValue('name'),
      is_alert: getDefaultValue('is_alert') || SanctionsStatus.All,
      country_code: getDefaultArray('country_code'),
      company_name: getDefaultValue('company_name'),
      company_address: getDefaultValue('company_address'),
      industry: getDefaultValue('industry'),
      profile_includes: getDefaultArray('profile_includes'),
      job_title: getDefaultValue('job_title'),
      jurisdiction: getDefaultValue('jurisdiction'),
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().max(255),
      is_alert: Yup.string().max(255),
      country_code: Yup.array().min(1, 'Please choose at least 1 country'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      handleClose();
      setSubmitting(false);
      values.country_code = listCountryCode;
      // if (values.is_alert === SanctionsStatus.All) {
      //   values.is_alert = 'false';
      // } else {
      //   values.is_alert = 'true';
      // }

      const params = handleQueryParamFromObject(values);
      navigate({ pathname: AuthRouteKeys.PeopleProfiles, search: params });
    },
  });

  const defaultValueCheckbox = (type: string, key: string) => {
    return includes(get(formik.values, type), key);
  };

  const listCountryCode = (formik.values?.country_code || []).map((country) =>
    typeof country === 'string' ? country : get(country, 'code', ''),
  );

  const handleClickMoreFilter = () => {
    setVisibleMoreFilter((prev) => {
      return !prev;
    });
  };

  const handleChangePeopleStatus = (e: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    formik.setFieldValue('is_alert', e.target.name);
  };

  const renderButtonMoreFilter = () => {
    if (!visibleMoreFilter) {
      return (
        <Button onClick={handleClickMoreFilter} color="suggestion" size="small" variant="text">
          Advanced Search{' '}
          <IconFeather muiProps={{ color: 'inherit', fontSize: 'small' }} icon={<ChevronsDown size={24} />} />
        </Button>
      );
    } else {
      return (
        <Button onClick={handleClickMoreFilter} color="suggestion" size="small" variant="text">
          Basic Search{' '}
          <IconFeather muiProps={{ color: 'inherit', fontSize: 'small' }} icon={<ChevronsUp size={24} />} />
        </Button>
      );
    }
  };

  const formMoreFilter = (
    <React.Fragment>
      <FormItemStatePeople
        id="jurisdiction"
        label="State"
        countryCode={listCountryCode}
        disabled={listCountryCode.length === 0}
      />
      <FormItemIndustryPeople id="industry" countryCode={listCountryCode} disabled={listCountryCode.length === 0} />
      <Box>
        <FormControl>
          <FormLabel id="is_alert">
            <Typography variant="caption2">Profile Status</Typography>
          </FormLabel>
          <RadioGroup row aria-labelledby="is_alert" name="row-radio-buttons-group">
            {SearchPeopleStatus.map(({ label, value }) => {
              const checked = value === String(formik.values.is_alert);
              return (
                <FormControlLabel
                  value={value}
                  key={value}
                  control={
                    <Radio
                      id={value}
                      name={value}
                      onChange={(e, value) => handleChangePeopleStatus(e, value)}
                      onBlur={formik.handleBlur}
                      checked={checked}
                      size="small"
                    />
                  }
                  label={<Typography variant="caption2">{label}</Typography>}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      </Box>
      <Box>
        <InputLabel shrink color="primary">
          Profile Data Includes
        </InputLabel>
        <FieldArray
          name="profile_includes"
          render={({ remove, push }) =>
            SearchProfileIncludes.map(({ label, value }) => (
              <FormControlLabel
                key={value}
                sx={{ ml: -1 }}
                control={
                  <Checkbox
                    checked={defaultValueCheckbox('profile_includes', value)}
                    onChange={(_, checked) => {
                      if (checked) {
                        push(value);
                      } else {
                        const index = indexOf(formik.values.profile_includes, value);
                        remove(index);
                      }
                    }}
                    size="small"
                    color="primary"
                    id={value}
                    name={value}
                  />
                }
                label={
                  <Typography color={'text.secondary'} variant="caption2">
                    {label}
                  </Typography>
                }
              />
            ))
          }
        />
      </Box>
    </React.Fragment>
  );

  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open}>
      <FormikForm formik={formik}>
        <Box width={540}>
          <Typography textAlign={'center'} variant="h5">
            People Search
          </Typography>
          <Box sx={{ mt: 1 }} />
          <Typography textAlign="center" color="text.secondary" variant="body2">
            Please enter your search criteria below. The more fields you complete, the more targeted your results will
            be.{' '}
            <Link to={PEOPLE_URL_VIDEO} target="_blank">
              <Typography color={'secondary'} textAlign={'center'} variant="caption">
                Learn more
              </Typography>
            </Link>
          </Typography>
          <Box sx={{ mt: 4 }} />
          <Stack direction={'column'} spacing={3}>
            <FormItemCountryMulti
              listOfCompleteCountriesData={runTimeConfig?.COUNTRY_AVAILABLE_FOR_OFFICIAL_PEOPLE_DATA}
              id="country_code"
              required
            />
            <FormItemSuggestName id="name" freeSolo={true} countryCode={listCountryCode} />
            <TextField
              id="job_title"
              name="job_title"
              value={get(formik.values, 'job_title', '')}
              size="small"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              error={Boolean(formik.touched.job_title && formik.errors.job_title)}
              helperText={Boolean(formik.touched.job_title) && formik.errors.job_title}
              label="Job Title"
            />
            <FormItemSuggestCompany
              id="company_name"
              disabled={listCountryCode.length === 0}
              freeSolo={true}
              countryCode={listCountryCode}
            />

            {visibleMoreFilter && formMoreFilter}
            {renderButtonMoreFilter()}
            <ButtonWithLoading sx={{ height: 53 }} size="large" variant="contained" isRounded type="submit">
              Search Now
            </ButtonWithLoading>
          </Stack>
        </Box>
      </FormikForm>
    </ModalComponent>
  );
};

export default FormSearchPeople;
